import { render, staticRenderFns } from "./CourseLiveOnlineDetail.vue?vue&type=template&id=4648ab80&scoped=true&"
import script from "./CourseLiveOnlineDetail.vue?vue&type=script&lang=js&"
export * from "./CourseLiveOnlineDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseLiveOnlineDetail.vue?vue&type=style&index=0&id=4648ab80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648ab80",
  null
  
)

export default component.exports